import React from "react";
import { useI18n } from "@/i18n/I18nProvider";

// Marquee with a tactical mantra repeated. Adds rhythm between sections.
export default function Ticker() {
  const { t, locale } = useI18n();
  const phrase = locale === "pt-BR"
    ? "CONQUISTE SUA DOPAMINA"
    : "EARN YOUR DOPAMINE";

  const items = Array.from({ length: 14 }).map((_, i) => i);

  return (
    <div data-testid="ticker" className="relative border-y overflow-hidden mask-fade-x"
         style={{ borderColor: "rgba(245,247,250,0.08)", background: "#0B0F14" }}>
      <div className="flex animate-ticker whitespace-nowrap py-5">
        {[...items, ...items].map((i) => (
          <span
            key={i}
            className="mono-num text-ink/30 text-sm md:text-base px-8 flex items-center gap-8"
          >
            {phrase}
            <span className="inline-block h-1 w-1 rounded-full bg-primary" />
          </span>
        ))}
      </div>
    </div>
  );
}
